export default __webpack_public_path__ + "static/media/mail.b0ca48ee.svg";